import { getBaseURL } from '@core/EnvUtils'
import { Router } from '@core/Constants'

export function getMainFrameBaseUrl(withoutSiteBase = false): string {
  const baseURL = getBaseURL()

  return Array.of(withoutSiteBase ? '/' : baseURL, Router.MAIN_APP).join('')
}

export function getMicroAppPreviewBaseUrl(withoutSiteBase = false): string {
  const baseURL = getBaseURL()

  return Array.of(withoutSiteBase ? '/' : baseURL, Router.MICRO_APP_PREVIEW_BASE).join('')
}

export function getMicroAppBaseUrl(withoutSiteBase = false): string {
  const baseURL = getBaseURL()

  return Array.of(withoutSiteBase ? '/' : baseURL, Router.MICRO_APP_MAIN).join('')
}
